import debounce from 'lodash/debounce';
export default {
  data() {
    return {
      valid: {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      },
      success: {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      },
      error: {
        minimum_amount: [''],
        expiration_days: [''],
        valid_days_before: [''],
        title: [''],
        description: [''],
      },
      errorMessages: {
        minimumAmountRequired: {
          el: 'Προσθέστε το ελάχιστο ποσό για αυτό το πακέτο',
          en: 'Please add the minimum amount for this package.',
          it: "Si prega di aggiungere l'importo minimo  per questo pacchetto.",
        },
        minimumAmountGreaterThan100: {
          el: 'Αυτός ο αριθμός δεν μπορεί να είναι μικρότερος του 100',
          en: 'This number cannot be less than 100',
          it: 'Questo numero non può essere inferiore a 100',
        },
        minimumAmountExceededFrom: {
          el: 'Ο ελάχιστος αριθμός πρέπει να είναι μεγαλύτερος από',
          en: 'This number must be greater than',
          it: 'Questo numero non può essere inferiore al numero minimo del livello precedente',
        },
        minimumAmountExceededTo: {
          el: 'Ο αριθμός αυτός πρέπει να είναι μικρότερος από',
          en: 'This number must be less than',
          it: 'Questo numero deve essere inferiore al',
        },
        maximumAmountRequired_points: {
          el: 'Προσθέστε το μέγιστο αριθμό πόντων για αυτό το πακέτο.',
          en: 'Please add the maximum amount of points for this package.',
          it: "Si prega di aggiungere l'importo massimo di punti per questo pacchetτο",
        },
        maximumAmountRequired_cashback: {
          el: 'Προσθέστε το μέγιστο ποσό cashback για αυτό το πακέτο.',
          en: 'Please add the maximum amount of cashback for this package.',
          it: "Si prega di aggiungere l'importo massimo di cashback per questo pacchetto",
        },
        maximumAmountExceededFrom: {
          el: 'Ο μέγιστος αριθμός πρέπει να είναι μεγαλύτερος από τον ελάχιστο αριθμό αριθμό πόντων της βαθμίδας του',
          en: "This number must be greater than the tier's minimum number of points",
          it: 'Questo numero deve essere superiore al numero minimo di punti previsto dal livello',
        },
        maximumAmountExceededTo: {
          el: 'Ο μέγιστος αριθμός πρέπει να είναι μικρότερος από τον μέγιστο αριθμό της επόμενης βαθμίδας',
          en: 'This number cannot exceed the maximum number of the next tier',
          it: 'Questo numero non può superare il numero massimo del livello successivo',
        },
        multiplierRequired_points: {
          el: 'Προσθέστε το πολλαπλασιαστή πόντων για αυτό το πακέτο.',
          en: 'Please add the point multiplier for this package.',
          it: 'Si prega di aggiungere il moltiplicatore di punti per questo pacchetto.',
        },
        multiplierRequired_cashback: {
          el: 'Προσθέστε το πολλαπλασιαστή cashback για questo pacchetto.',
          en: 'Please add the cashback multiplier for this package.',
          it: 'Si prega di aggiungere il moltiplicatore di cashback per questo pacchetto.',
        },
        multiplierNaN: {
          el: 'Mη έγκυρη τιμή',
          en: 'Invalid value',
          it: 'Valore non valido',
        },
        titleRequired: {
          el: 'Προσθέστε έναν τίτλο για αυτό το πακέτο.',
          en: 'Please add a title for this package.',
          it: 'Aggiungi un titolo per questo pacchetto.',
        },
        descriptionRequired: {
          el: 'Προσθέστε μια περιγραφή για αυτό το πακέτο.',
          en: 'Please add a description for this package.',
          it: 'Aggiungi una descrizione per questo pacchetto.',
        },
        expirationDaysRequired: {
          el: 'Προσθέστε ημέρες λήξεως επιπέδου.',
          en: "Please add the tier's expiration days.",
          it: 'Aggiungere i giorni di scadenza del livello.',
        },
        countableDaysRequired: {
          el: 'Προσθέστε έγκυρο θετικό αριθμό ημερών υπολογίσιμων συναλλαγών επιπέδου.',
          en: "Please add a valid positive number for the tier's Countable transactions days.",
          it: 'Aggiungere un numero valido per i giorni di transazioni conteggiabili del livello.',
        },
      },
    };
  },

  computed: {
    tiersValid() {
      // Check all valid arrays
      const allValid =
        this.valid.expiration_days.every(Boolean) &&
        this.valid.valid_days_before.every(Boolean) &&
        this.valid.title.every(Boolean) &&
        this.valid.description.every(Boolean) &&
        this.valid.minimum_amount.every(Boolean);

      // Check all error arrays (no non-empty string allowed)
      const noErrors =
        this.error.expiration_days.every((err) => !err) &&
        this.error.valid_days_before.every((err) => !err) &&
        this.error.title.every((err) => !err) &&
        this.error.description.every((err) => !err) &&
        this.error.minimum_amount.every((err) => !err);
      return allValid && noErrors;
    },
  },

  methods: {
    validateTierForm(i, tierData) {
      this.validateTitle({ i, tierData });
      this.validateDescription({ i, tierData });
      this.validateExpirationDays({ i, tierData });
      this.validateCountableDays({ i, tierData });
      return this.formValid;
    },
    validateMinimumAmount(i, tierData, validateAdjacents = false) {
      const tierIndex = Number.isInteger(i) ? i : this.tierIndex;
      const tierDataLocal = tierData || this.tierData;
      this.valid.minimum_amount[tierIndex] = false;
      this.success.minimum_amount[tierIndex] = false;
      this.error.minimum_amount[tierIndex] = '';
      this.$set(this.error.minimum_amount, tierIndex, '');
      this.$set(this.valid.minimum_amount, tierIndex, false);
      this.$set(this.valid.minimum_amount, 0, true);

      if (tierIndex <= 0) {
        this.$set(this.valid.minimum_amount, tierIndex, true);
        return true;
      } else if (!tierDataLocal.from) {
        this.$set(
          this.error.minimum_amount,
          tierIndex,
          this.errorMessages.minimumAmountRequired[this.lang]
        );
      } else if (
        validateAdjacents &&
        Number(tierDataLocal.from) <= Number(this.tierValues[tierIndex - 1].from)
      ) {
        this.$set(
          this.error.minimum_amount,
          tierIndex,
          this.errorMessages.minimumAmountExceededFrom[this.lang] +
            ': ' +
            Number(this.tierValues[tierIndex - 1].from)
        );
      } else if (
        validateAdjacents &&
        this.tierValues[tierIndex + 1] &&
        tierDataLocal.to &&
        Number(tierDataLocal.from) >= Number(this.tierValues[tierIndex + 1].from)
      ) {
        this.$set(
          this.error.minimum_amount,
          tierIndex,
          this.errorMessages.minimumAmountExceededTo[this.lang] +
            ': ' +
            this.tierValues[tierIndex + 1].from
        );
      } else {
        if (!this.tierValues[tierIndex + 1]) {
          this.tierValues[tierIndex].to = parseInt(tierDataLocal.from * this.infinityMultiplier);
        }

        this.$set(this.error.minimum_amount, tierIndex, '');
        this.$set(this.valid.minimum_amount, tierIndex, true);
      }

      if (validateAdjacents) {
        if (
          this.tierValues[tierIndex - 1] &&
          tierIndex > 1 &&
          this.tierValues[tierIndex - 1]?.errors?.length
        ) {
          this.validateMinimumAmount(tierIndex - 1, this.tierValues[tierIndex - 1]);
        }
        if (this.tierValues[tierIndex + 1] && this.tierValues[tierIndex + 1]?.errors?.length) {
          this.validateMinimumAmount(tierIndex + 1, this.tierValues[tierIndex + 1]);
        }
      }
    },

    validateExpirationDays({ i, tierData } = {}) {
      const tierIndex = Number.isInteger(i) ? i : this.tierIndex;
      const tierDataLocal = tierData || this.tierData;
      this.$set(this.valid.expiration_days, tierIndex, false);
      if (tierIndex === 0) {
        this.$set(this.valid.expiration_days, tierIndex, true);
        this.$set(this.error.expiration_days, tierIndex, '');
        return true;
      }
      if (this.tiers_settings.system === 'expiration_mode' && tierDataLocal.expiration_days <= 0) {
        this.$set(
          this.error.expiration_days,
          tierIndex,
          this.errorMessages.expirationDaysRequired[this.lang]
        );
      } else {
        this.$set(this.error.expiration_days, tierIndex, '');
        this.$set(this.valid.expiration_days, tierIndex, true);
      }
    },

    validateCountableDays({ i, tierData } = {}) {
      const tierIndex = Number.isInteger(i) ? i : this.tierIndex;
      const tierDataLocal = tierData || this.tierData;

      if (tierIndex === 0 || this.tiers_settings.system !== 'expiration_mode') {
        this.$set(this.error.valid_days_before, tierIndex, '');
        this.$set(this.valid.valid_days_before, tierIndex, true);
        this.$set(this.success.valid_days_before, tierIndex, true);
        return true;
      }

      try {
        const value = tierDataLocal.valid_days_before;
        const numericValue = Number(value);
        const isEmpty = value === '' || value === null || typeof value === 'undefined';

        if (isEmpty || Number.isNaN(numericValue) || numericValue < 0) {
          this.$set(
            this.error.valid_days_before,
            tierIndex,
            this.errorMessages.countableDaysRequired[this.lang]
          );
          this.$set(this.valid.valid_days_before, tierIndex, false);
          this.$set(this.success.valid_days_before, tierIndex, false);
        } else {
          this.$set(this.error.valid_days_before, tierIndex, '');
          this.$set(this.valid.valid_days_before, tierIndex, true);
          this.$set(this.success.valid_days_before, tierIndex, true);
        }
      } catch (error) {
        this.$set(
          this.error.valid_days_before,
          tierIndex,
          this.errorMessages.countableDaysRequired[this.lang]
        );
        this.$set(this.valid.valid_days_before, tierIndex, false);
        this.$set(this.success.valid_days_before, tierIndex, false);
      }
    },

    validateTitle({ i, tierData } = {}) {
      const tierIndex = Number.isInteger(i) ? i : this.tierIndex;
      const tierDataLocal = tierData || this.tierData;

      const titles = tierDataLocal?.title || {};
      const hasValue = Object.values(titles).some((val) => String(val || '').trim().length > 0);
      if (!hasValue) {
        this.$set(this.error.title, tierIndex, this.errorMessages.titleRequired[this.lang]);
        this.$set(this.valid.title, tierIndex, false);
        this.$set(this.success.title, tierIndex, false);
      } else {
        this.$set(this.error.title, tierIndex, '');
        this.$set(this.valid.title, tierIndex, true);
        this.$set(this.success.title, tierIndex, true);
      }
    },

    validateDescription({ i, tierData } = {}) {
      const tierIndex = Number.isInteger(i) ? i : this.tierIndex;
      const tierDataLocal = tierData || this.tierData;

      const descriptions = tierDataLocal?.description || {};
      const hasValue = Object.values(descriptions).some(
        (val) => String(val || '').trim().length > 0
      );

      if (!hasValue) {
        this.$set(
          this.error.description,
          tierIndex,
          this.errorMessages.descriptionRequired[this.lang]
        );
        this.$set(this.valid.description, tierIndex, false);
        this.$set(this.success.description, tierIndex, false);
      } else {
        this.$set(this.error.description, tierIndex, '');
        this.$set(this.valid.description, tierIndex, true);
        this.$set(this.success.description, tierIndex, true);
      }
    },

    resetSuccess() {
      this.success = {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      };
    },

    resetErrors() {
      this.$set(this, 'error', {
        minimum_amount: [''],
        expiration_days: [''],
        valid_days_before: [''],
        title: [''],
        description: [''],
      });
    },

    resetValidation() {
      this.resetErrors();
      this.valid = {
        minimum_amount: [true],
        expiration_days: [true],
        valid_days_before: [true],
        title: [false],
        description: [false],
      };
    },
  },

  watch: {
    ['tierData.from']: {
      immediate: true,
      handler(val) {
        if (this.tierIndex > 0) {
          this.valid.minimum_amount[this.tierIndex] = !!val;
          this.success.minimum_amount[this.tierIndex] = !!val;
        }
        this.valid.minimum_amount[0] = true;
        this.success.minimum_amount[0] = true;
      },
    },

    ['tierData.expiration_days']: {
      immediate: true,
      handler(val) {
        this.valid.expiration_days[this.tierIndex] =
          val > 0 || this.tiers_settings.system !== 'expiration_mode' || this.tierIndex === 0;
        this.success.expiration_days[this.tierIndex] =
          val > 0 || this.tiers_settings.system !== 'expiration_mode' || this.tierIndex === 0;
      },
    },

    ['tierData.valid_days_before']: {
      immediate: true,
      handler(val) {
        if (this.tierIndex === 0 || this.tiers_settings.system !== 'expiration_mode') {
          this.$set(this.valid.valid_days_before, this.tierIndex, true);
          this.$set(this.success.valid_days_before, this.tierIndex, true);
          return;
        }

        const numericValue = Number(val);
        const isEmpty = val === '' || val === null || typeof val === 'undefined';
        const isValid = !isEmpty && !Number.isNaN(numericValue) && numericValue >= 0;

        this.$set(this.valid.valid_days_before, this.tierIndex, isValid);
        this.$set(this.success.valid_days_before, this.tierIndex, isValid);
      },
    },

    ['tierData.title']: {
      deep: true,
      handler(val) {
        this.valid.title[this.tierIndex] = !!(val.en || val.el || val.it);
        this.success.title[this.tierIndex] = !!(val.en || val.el || val.it);
      },
    },

    ['tierData.description']: {
      deep: true,
      handler(val) {
        this.valid.description[this.tierIndex] = !!(val.en || val.el || val.it);
        this.success.description[this.tierIndex] = !!(val.en || val.el || val.it);
      },
    },
  },
  created() {
    this.debouncedValidation = debounce(this.validateTierForm, 800);
  },
};
